import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export class ContractorsRequest extends GenericRequest {

    // ContractorCriteria: {
    //     term : string
    //     page : number
    //     only_active : boolean
    //     only_inactive : boolean
    //     show_only_deleted : boolean
    // }

    contractorCriteria;

    constructor(contractorCriteria) {
        super(METHOD_POST, ApiEndpoints.CONTRACTORS);
        this.contractorCriteria = contractorCriteria;
    }

    overrideRequest() {
        return this.contractorCriteria;
    }

}



// WEBPACK FOOTER //
// ./src/app/contractors/ws/ContractorsRequest.js